import { handleResponse } from './handleResponse';

interface IApiFetch {
  url: string;
  body?: Object | null;
  token?: string | null;
}

export async function apiGet<T>(url: string, token?: string | null): Promise<T> {
  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      ...(token && { token }),
    },
  }).then(handleResponse);
}

async function apiFetch<T>({ method, url, body, token }: IApiFetch & { method: string }): Promise<T> {
  const isFormData = body instanceof FormData;
  return fetch(url, {
    method,
    credentials: 'include',
    headers: {
      ...(body && !isFormData && { 'Content-Type': 'application/json' }),
      ...(token && { token }),
    },
    body: isFormData ? body : JSON.stringify(body),
  }).then(handleResponse);
}

export async function apiPost<T>(params: IApiFetch): Promise<T> {
  return apiFetch({ method: 'POST', ...params });
}
